export const P1_WARNING_SUFFIX = 'ostrzezenie';
export const P1_ERROR_SUFFIX = 'blad';